import React from "react";

const Error = () => {
  return (
    <div className="container text-center">
      <h1 className="header-4">404</h1>
      <a href="../" className="link large-text">
        Go back home
      </a>
    </div>
  );
};

export default Error;
